import { render, staticRenderFns } from "./CustomerCrmSnapshotList.vue?vue&type=template&id=24d73abd&scoped=true&"
import script from "./CustomerCrmSnapshotList.vue?vue&type=script&lang=js&"
export * from "./CustomerCrmSnapshotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d73abd",
  null
  
)

export default component.exports